export default "__VITE_ASSET__dJVK4kYT__"